import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["authType", "name", "onContent", "onError", "onNoContent", "onVideoEngagement", "onVideoFinish", "onVideoPlay", "onVideoProgress", "onWatermarkClick", "variant"];
import PropTypes from 'prop-types';
import { Frame } from './Frame';
import { useSyncStaticState } from '../hooks/staticWidgetHooks';
import { useSyncIFrameHeight } from '../hooks/syncIFrameHeightHooks';
import { View } from 'foundations-components/components/View';
import ACSkeletonBox from 'academy-common-lib/components/loading/ACSkeletonBox';
import { useState } from 'react';
import * as Hublets from 'hubspot-url-utils/hublets-next';
import { renderContexts } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const propTypes = {
  Description: PropTypes.func,
  Link: PropTypes.func,
  Title: PropTypes.func,
  authType: PropTypes.oneOf(['app', 'public']),
  autoPlay: PropTypes.bool,
  contentId: PropTypes.number,
  enablePictureInPicture: PropTypes.bool,
  hublet: PropTypes.oneOf(Object.keys(Hublets)),
  language: PropTypes.string,
  lessonId: PropTypes.number,
  mutedByDefault: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onContent: PropTypes.func,
  onError: PropTypes.func,
  onNoContent: PropTypes.func,
  onVideoEngagement: PropTypes.func,
  onVideoFinish: PropTypes.func,
  onVideoPlay: PropTypes.func,
  onVideoProgress: PropTypes.func,
  onWatermarkClick: PropTypes.func,
  portalId: PropTypes.string,
  renderContext: PropTypes.oneOf(renderContexts),
  shortId: PropTypes.number,
  startTime: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'video'])
};
export const StaticContentWidget = _ref => {
  let {
      authType,
      name,
      onContent,
      onError,
      onNoContent,
      onVideoEngagement,
      onVideoFinish,
      onVideoPlay,
      onVideoProgress,
      onWatermarkClick,
      variant = 'default'
    } = _ref,
    rest$ = _objectWithoutPropertiesLoose(_ref, _excluded);
  const rest = Object.assign({
    variant
  }, rest$);
  const [isLoading, setIsLoading] = useState(true);
  const handleOnContent = content => {
    setIsLoading(false);
    if (onContent) onContent(content);
  };
  const handleOnError = () => {
    setIsLoading(false);
    if (onError) onError();
  };
  const handleOnNoContent = () => {
    setIsLoading(false);
    if (onNoContent) onNoContent();
  };
  const {
    registerIFrame: registerSyncHeight,
    height
  } = useSyncIFrameHeight();
  const {
    registerIFrame: registerSyncDynamic
  } = useSyncStaticState({
    newState: Object.assign({
      authType
    }, rest),
    onContent: handleOnContent,
    onError: handleOnError,
    onNoContent: handleOnNoContent,
    onVideoEngagement,
    onVideoFinish,
    onVideoPlay,
    onVideoProgress,
    onWatermarkClick
  });
  return /*#__PURE__*/_jsxs(View, {
    position: "relative",
    children: [/*#__PURE__*/_jsx(View, {
      "data-testid": "static-content-loading",
      inlineSize: "100%",
      marginBlockEnd: "200",
      position: "absolute",
      visibility: isLoading ? 'visible' : 'hidden',
      children: /*#__PURE__*/_jsx(ACSkeletonBox, {
        animated: true,
        style: {
          width: '100%',
          aspectRatio: '16 / 9'
        }
      })
    }), /*#__PURE__*/_jsx(View, {
      visibility: isLoading ? 'hidden' : 'visible',
      children: /*#__PURE__*/_jsx(Frame, {
        height: height,
        name: name,
        refHandlers: [registerSyncHeight, registerSyncDynamic],
        targetWidget: authType === 'public' ? 'staticPublic' : 'static'
      })
    })]
  });
};
StaticContentWidget.propTypes = propTypes;